var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose, Type } from 'class-transformer';
import { IsArray } from 'class-validator';
import { FeatureFlagFullSizeDto } from '../../feature-flag/index.js';
import { OfficeLocationFullSizeDto } from '../../offices/index.js';
import { TourStatusFullSizeDto } from '../../tours/dto/tour-status.full-size.dto.js';
import { UserSettingsFullSizeDto } from './user-settings.full-size.dto.js';
import { UserLiteDto } from './user.lite.dto.js';
export class UserInfoFullSizeDto {
    user;
    featureFlags;
    settings;
    officeLocations;
    tourStatus;
}
__decorate([
    Expose(),
    Type(() => UserLiteDto),
    __metadata("design:type", Function)
], UserInfoFullSizeDto.prototype, "user", void 0);
__decorate([
    Expose(),
    IsArray(),
    Type(() => FeatureFlagFullSizeDto),
    __metadata("design:type", Array)
], UserInfoFullSizeDto.prototype, "featureFlags", void 0);
__decorate([
    Expose(),
    Type(() => UserSettingsFullSizeDto),
    __metadata("design:type", UserSettingsFullSizeDto)
], UserInfoFullSizeDto.prototype, "settings", void 0);
__decorate([
    Expose(),
    Type(() => OfficeLocationFullSizeDto),
    __metadata("design:type", Array)
], UserInfoFullSizeDto.prototype, "officeLocations", void 0);
__decorate([
    Expose(),
    Type(() => TourStatusFullSizeDto),
    __metadata("design:type", TourStatusFullSizeDto)
], UserInfoFullSizeDto.prototype, "tourStatus", void 0);
//# sourceMappingURL=user-info.full-size.dto.js.map